import React from 'react'
import { Card } from 'antd'
import { CustomTitle } from 'src/components'
import { useTranslation } from 'next-i18next'
import styles from './RestorePasswordCard.module.scss'
import RestorePasswordForm from './RestorePasswordForm/RestorePasswordForm'

const RestorePasswordCard: React.FC = () => {
  const { t } = useTranslation()

  return <Card
    loading={false}
    className={styles.card}
    title={<CustomTitle label={t('Auth.Password.RestoreLabel')} type={null} />}
  >
    <RestorePasswordForm />
  </Card>
}

export default RestorePasswordCard
